import { CompanyCreateForm } from 'modules/company/components/CompanyCreateForm';
import { CompanyUpdateForm } from 'modules/company/components/CompanyUpdateForm';
import React, { FunctionComponent } from 'react';

export type CompanyFormModalProps = {
  open: boolean;
  onClose: () => void;
  billingEmailSuggestions: string[];
};

type CompanyFormProps = CompanyFormModalProps & {
  companyId?: number | null;
  onCompanyCreated?: (companyId: number) => void;
  onCompanyUpdated?: () => void;
  billingEmailSuggestions: string[];
};

const CompanyFormModal: FunctionComponent<CompanyFormProps> = ({
  companyId,
  onCompanyUpdated,
  onCompanyCreated,
  ...rest
}) => {
  return (
    <>
      {companyId ? (
        <CompanyUpdateForm
          companyId={companyId}
          onCompanyUpdated={onCompanyUpdated}
          {...rest}
        />
      ) : (
        <CompanyCreateForm onCompanyCreated={onCompanyCreated} {...rest} />
      )}
    </>
  );
};

export default CompanyFormModal;
